import { EpimsBaseEntityDto } from './epim-base.dto';

export class ReportReferenceDto extends EpimsBaseEntityDto {

    PurposeId: string;

    CompanyName: string;
    Logo: string;
    SubscriberId: string;
    SubscriptionUserId: string;
}
